<template>
  <div class="coupon-list">
    
    <div class="left content-left">
      <div class="merchant-tree" v-loading="treeLoading">
        <el-input
          class="search"
          placeholder="输入关键字搜索商家"
          v-model="merchantFilterText"
          clearable
        ></el-input>
        <el-tree
          ref="merchantTree"
          :data="merchantTreeData"
          :props="merchantTreeProps"
          @node-click="handleTreeClick"
          node-key="id"
          :highlight-current="true"
          :show-checkbox="false"
          :expand-on-click-node="true"
          :filter-node-method="filterMerchantNode"
          :default-expand-all="true"
        >
          <span slot-scope="{ node, data }" class="merchant-tree-node">
            <span class="merchant-name-wrapper">
              <span 
                class="merchant-name" 
                :title="node.label"
              >{{ node.label }}</span>
              <span
                v-if="data.type === 'merchant' && data.published !== undefined"
                class="merchant-status-badge"
              >
                <el-tag
                  :type="getMerchantStatusType(data.published)"
                  size="mini"
                >
                  {{ getMerchantStatusText(data.published) }}
                </el-tag>
              </span>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    
    <div class="right content-right">
      
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <el-input
              v-model="search.couponName"
              placeholder="请输入优惠券名称"
            ></el-input>
          </div>
          <div class="form-group">
            <el-select
              v-model="search.discountType"
              placeholder="请选择优惠券类型"
            >
              <el-option label="全部" value=""></el-option>
              
               <el-option label="赠送券" value="4"></el-option>
              <el-option label="折扣券" value="3"></el-option>
              <el-option label="抵扣券" value="5"></el-option>
            </el-select>
          </div>

          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
               :disabled="listLoading">
              <i v-if="listLoading" class="el-icon-loading"></i>
              {{ listLoading ? "查询中..." : "查询" }}
            </button>
            </span>
          </div>
        </form>
      </div>
      <template>
        
        <div class="status-tabs">
          <el-tabs v-model="activeStatus" @tab-click="handleStatusChange">
            <el-tab-pane label="全部" name="all">
              <span slot="label">
                全部
                <el-badge :value="all" class="status-badge" />
              </span>
            </el-tab-pane>
            <el-tab-pane label="待审核" name="pending">
              <span slot="label">
                待审核
                <el-badge :value="statusCounts.pending" class="status-badge" />
              </span>
            </el-tab-pane>
            <el-tab-pane label="审核不通过" name="rejected">
              <span slot="label">
                审核不通过
                <el-badge :value="statusCounts.rejected" class="status-badge" />
              </span>
            </el-tab-pane>
            <el-tab-pane label="上架中" name="online">
              <span slot="label">
                上架中
                <el-badge :value="statusCounts.online" class="status-badge" />
              </span>
            </el-tab-pane>
            <el-tab-pane label="下架中" name="offline">
              <span slot="label">
                下架中
                <el-badge :value="statusCounts.offline" class="status-badge" />
              </span>
            </el-tab-pane>
            <el-tab-pane label="已失效" name="expired">
              <span slot="label">
                已失效
                <el-badge :value="statusCounts.expired" class="status-badge" />
              </span>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div v-show="showList" class="list-right" v-loading="listLoading">
          <el-table
            ref="table"
            border
            :data="tableListData"
            height="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
            <el-table-column
              show-overflow-tooltip
              label="商家名称"
              prop="merchantName"
              width="120"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="优惠券名称"
              prop="name"
              width="150"
            ></el-table-column>

            <el-table-column
              show-overflow-tooltip
              label="优惠券类型"
              prop="discountType"
              width="120"
            >
              <template slot-scope="scope">
                <span>{{ getCouponTypeName(scope.row.discountType) }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              show-overflow-tooltip
              label="优惠券内容"
              prop="couponContent"
              width="200"
            ></el-table-column> -->
            <el-table-column
              show-overflow-tooltip
              label="发放数量"
              prop="totalNum"
              width="100"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="已领取数量"
              prop="issueNum"
              width="120"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="已核销数量"
              prop="usedNum"
              width="120"
            ></el-table-column>
            <!-- <el-table-column
              show-overflow-tooltip
              label="领取未核销数量"
              prop="unusedCount"
              width="140"
            ></el-table-column> -->
            <el-table-column
              show-overflow-tooltip
              label="上架有效期"
              width="300"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.issueBeginTime && scope.row.issueEndTime"
                  >{{ scope.row.issueBeginTime }} -
                  {{ scope.row.issueEndTime }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="使用有效期"
              width="300"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.termBeginTime && scope.row.termEndTime"
                  >{{ scope.row.termBeginTime }} -
                  {{ scope.row.termEndTime }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="可用时间段"
              width="150"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.durationStart && scope.row.durationEnd"
                  >{{ scope.row.durationStart }} -
                  {{ scope.row.durationEnd }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="状态"
              prop="status"
              width="100"
            >
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row)">
                  {{ getStatusName(scope.row) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="创建时间"
              prop="crtTime"
              width="150"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="更新时间"
              prop="updTime"
              width="150"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="排序"
              width="120"
            >
              <template slot-scope="scope">
                <div class="sort-edit-container">
                  <span v-if="!scope.row.editingSort" class="sort-display">
                    {{ scope.row.sort }}
                    <i 
                      class="el-icon-edit sort-edit-icon" 
                      @click="startSortEdit(scope.row)"
                      v-if="scope.row.auditStatus === 0 && scope.row.published === 1"
                      title="点击编辑排序"
                    ></i>
                  </span>
                  <div v-else class="sort-edit-input">
                    <el-input-number
                      v-model="scope.row.tempSort"
                      :min="0"
                      :max="9999"
                      size="mini"
                      style="width: 80px;"
                    ></el-input-number>
                    <i 
                      class="el-icon-check sort-confirm-icon" 
                      @click="confirmSortEdit(scope.row)"
                    ></i>
                    <i 
                      class="el-icon-close sort-cancel-icon" 
                      @click="cancelSortEdit(scope.row)"
                    ></i>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="280px">
              <template slot-scope="scope">
                <!-- 待审核状态：显示审核按钮 -->
                <template
                  v-if="
                    scope.row.auditStatus === '1' || scope.row.auditStatus === 1
                  "
                >
                  <el-button
                    size="mini"
                    type="success"
                    @click="auditDialog(scope.row)"
                  >
                    审核
                  </el-button>
                </template>
                <!-- 上架中状态：显示设置抽奖规则和查看详情按钮 -->
                <template
                  v-else-if="
                    (scope.row.auditStatus === 0 || scope.row.auditStatus === '0') &&
                    (scope.row.published === 1 || scope.row.published === '1')
                  "
                >
                  <el-button
                    size="mini"
                    type="warning"
                    @click="openLotteryRuleDialog(scope.row)"
                  >
                    抽奖规则
                  </el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="viewDetail(scope.row)"
                  >
                    查看详情
                  </el-button>
                </template>
                <!-- 其他状态：显示查看详情按钮 -->
                <template v-else>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="viewDetail(scope.row)"
                  >
                    查看详情
                  </el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </div>

    <!-- 添加/编辑优惠券对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showAddDialog"
      width="800px"
      @close="closeDialog"
    >
      <el-form
        :model="couponForm"
        :rules="couponRules"
        ref="couponForm"
        label-width="120px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="优惠券名称" prop="couponName">
              <el-input
                v-model="couponForm.couponName"
                placeholder="请输入优惠券名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠券类型" prop="couponType">
              <el-select
                v-model="couponForm.couponType"
                placeholder="请选择优惠券类型"
              >
                <el-option label="满减券" value="1"></el-option>
                <el-option label="折扣券" value="2"></el-option>
                <el-option label="代金券" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="优惠券内容" prop="couponContent">
          <el-input
            v-model="couponForm.couponContent"
            type="textarea"
            placeholder="请输入优惠券内容"
          ></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发放数量" prop="totalCount">
              <el-input-number
                v-model="couponForm.totalCount"
                :min="1"
                :max="999999"
                placeholder="请输入发放数量"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="使用时间段" prop="useTimeRange">
              <el-input
                v-model="couponForm.useTimeRange"
                placeholder="如：09:00-18:00"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="上架有效期" prop="shelfValidPeriod">
              <el-date-picker
                v-model="couponForm.shelfValidPeriod"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="使用有效期" prop="useValidPeriod">
              <el-date-picker
                v-model="couponForm.useValidPeriod"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 设置抽奖规则右侧弹窗 -->
    <el-drawer
      :title="lotteryRuleTitle"
      :visible.sync="showLotteryRuleDrawer"
      direction="rtl"
      size="420px"
      :before-close="closeLotteryRuleDrawer"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px;">
        <el-form
          :model="lotteryRuleForm"
          :rules="lotteryRuleRules"
          ref="lotteryRuleForm"
          label-width="140px"
        >
          <el-form-item label="支付抽奖权重">
            <div class="payment-weight-container">
              <div class="payment-weight-item">
                <span class="payment-weight-label">无感支付：</span>
                <el-input-number
                  v-model="lotteryRuleForm.unawarePayWeight"
                  :min="0"
                  :max="100000"
                  :precision="0"
                  controls-position="right"
                  style="width: 200px;"
                ></el-input-number>
              </div>
              <div class="payment-weight-item">
                <span class="payment-weight-label">扫码支付：</span>
                <el-input-number
                  v-model="lotteryRuleForm.scanPayWeight"
                  :min="0"
                  :max="100000"
                  :precision="0"
                  controls-position="right"
                  style="width: 180px;"
                ></el-input-number>
              </div>
              <div class="payment-weight-item">
                <span class="payment-weight-label">小程序：</span>
                <el-input-number
                  v-model="lotteryRuleForm.miniProgramPayWeight"
                  :min="0"
                  :max="100000"
                  :precision="0"
                  controls-position="right"
                  style="width: 200px;"
                ></el-input-number>
              </div>
              <div class="payment-weight-tip">
                <i class="el-icon-info" style="color: #909399; margin-right: 4px;"></i>
                <span style="color: #909399; font-size: 12px; line-height: 1.5;">0表示不参与抽奖，数字越大抽中概率越高</span>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="每日最大发行" prop="dailyMaxIssue">
            <el-input-number
              v-model="lotteryRuleForm.dailyMaxIssue"
              :min="0"
              :max="999999"
              :precision="0"
              controls-position="right"
              placeholder="请输入每日最大发行量"
              style="width: 100%;"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="重复获得时间间隔" prop="repeatObtainInterval">
            <div style="display: flex; align-items: center; width: 100%;">
              <el-input-number
                v-model="lotteryRuleForm.repeatObtainInterval"
                :min="1"
                :max="365"
                :precision="0"
                controls-position="right"
                placeholder="请输入天数"
                style="flex: 1;"
              ></el-input-number>
              <span style="color: #909399; font-size: 12px; margin-left: 10px; white-space: nowrap;">天</span>
            </div>
          </el-form-item>

          <el-form-item >
            <el-checkbox v-model="lotteryRuleForm.defaultConsolationPrize">默认安慰奖</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: right; padding: 15px 20px; border-top: 1px solid #e4e7ed; background: #fafafa;">
        <el-button @click="closeLotteryRuleDrawer" size="small">取 消</el-button>
        <el-button type="primary" @click="submitLotteryRule" size="small">确 定</el-button>
      </div>
    </el-drawer>

    <!-- 分页组件 -->
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Page from "@/page/commons/page";
import {
  shopCouponList,
  couponAdd,
  couponUpdate,
  couponDelete,
  shopCouponCount,
  shopCouponAudit,
  shopMerchantList,
  couponLotteryConfigSelect,
  couponLotteryConfig,
} from "@/api/url";

export default {
  name: "coupon-list",
  components: {
    Page,
  },
  data() {
    return {
      moduleName: "coupon-list",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      tableListData: [],
      total: 8,
      showList: true,
      search: {
        limit: 10,
        page: 1,
        couponName: "",
        discountType: "",
        status: "",
        merchantId: "", // 商家ID，用于树节点筛选
      },
      selectedMerchant: null, // 当前选中的商家节点
      // 商家树相关
      merchantTreeData: [],
      merchantTreeProps: {
        children: "children",
        label: "name",
      },
      merchantFilterText: "", // 商家树搜索关键字
      // Loading状态
      listLoading: false, // 优惠券列表加载状态
      treeLoading: false, // 商家树加载状态
      currentRow: {},
      // 测试数据开关（设置为 true 时使用测试数据，不调用 API）
      useTestData: false,
      showAddDialog: false,
      dialogTitle: "添加优惠券",
      isEdit: false,
      couponForm: {
        id: null,
        couponName: "",
        couponType: "",
        couponContent: "",
        totalCount: 1,
        useTimeRange: "",
        shelfValidPeriod: [],
        useValidPeriod: [],
      },
      couponRules: {
        couponName: [
          { required: true, message: "请输入优惠券名称", trigger: "blur" },
        ],
        couponType: [
          { required: true, message: "请选择优惠券类型", trigger: "change" },
        ],
        couponContent: [
          { required: true, message: "请输入优惠券内容", trigger: "blur" },
        ],
        totalCount: [
          { required: true, message: "请输入发放数量", trigger: "blur" },
        ],
        shelfValidPeriod: [
          { required: true, message: "请选择上架有效期", trigger: "change" },
        ],
        useValidPeriod: [
          { required: true, message: "请选择使用有效期", trigger: "change" },
        ],
      },

      // 状态标签页相关
      activeStatus: "all",
      statusCounts: {
        all: 8,
        pending: 1,
        rejected: 1,
        online: 4,
        offline: 1,
        expired: 1,
      },
      // 抽奖规则设置相关
      showLotteryRuleDrawer: false,
      currentCouponId: null,
      currentCouponName: "",
      lotteryRuleTitle: "抽奖规则",
      hasLotteryConfig: false, // 是否存在抽奖规则配置
      lotteryConfigId: null, // 抽奖规则配置的ID（用于PUT请求）
      lotteryRuleForm: {
        unawarePayWeight: 0,
        scanPayWeight: 0,
        miniProgramPayWeight: 0,
        dailyMaxIssue: 0,
        repeatObtainInterval: 0, // 显示为天
        defaultConsolationPrize: false, // 复选框，布尔值
      },
      lotteryRuleRules: {
        dailyMaxIssue: [
          { required: true, message: "请输入每日最大发行量", trigger: "blur" },
        ],
        repeatObtainInterval: [
          { required: true, message: "请输入重复获得优惠券时间间隔", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
    all() {
      return (
        this.statusCounts.pending +
        this.statusCounts.rejected +
        this.statusCounts.online +
        this.statusCounts.offline +
        this.statusCounts.expired
      );
    },
  },
  mounted() {
    console.log("mounted");
    this.getMerchantTree();
    this.tableList(1);
    this.getStatistics();
  },
  watch: {
    merchantFilterText(val) {
      this.$refs.merchantTree.filter(val);
    },
  },
  methods: {
    ...mapMutations(["getPage"]),
    // 分页数据接收
    receivePaginationData(v1, v2) {
      this.search.page = v1;
      this.search.limit = v2;
      this.tableList(this.search.page);
    },
    getStatistics() {
      // 如果启用测试数据，从测试数据中计算统计数据
      if (this.useTestData) {
        const allData = this.getAllTestData();
        let filteredData = allData;
        
        // 如果选中了商家，则过滤该商家的数据
        const hasMerchantId = this.search.merchantId && this.search.merchantId !== "";
        if (hasMerchantId) {
          filteredData = filteredData.filter(item => item.merchantId == this.search.merchantId);
        }
        
        // 计算各状态数量
        const statusCounts = {
          pending: filteredData.filter(item => item.auditStatus === 1).length,
          rejected: filteredData.filter(item => item.auditStatus === 2).length,
          online: filteredData.filter(item => item.auditStatus === 0 && item.published === 1).length,
          offline: filteredData.filter(item => item.auditStatus === 0 && item.published === 2).length,
          expired: filteredData.filter(item => item.status === 2).length,
        };
        
        this.statusCounts = statusCounts;
        return;
      }
      
      // 构建请求参数
      const params = {};
      // 如果选中了商家，则添加 merchantId 参数
      const hasMerchantId = this.search.merchantId && this.search.merchantId !== "";
      if (hasMerchantId) {
        params.merchantId = this.search.merchantId;
      }
      
      this.$get(shopCouponCount(), params).then((res) => {
        console.log("优惠券统计数据:", res);
        
        let statusCounts = {
          pending: 0,
          rejected: 0,
          online: 0,
          offline: 0,
          expired: 0,
        };
        
        if (hasMerchantId) {
          // 有 merchantId 时，返回单个商家数据，直接使用第一个元素
          const data = res?.data?.[0] || {};
          statusCounts = {
            pending: data.pend || 0,
            rejected: data.fail || 0,
            online: data.published || 0,
            offline: data.nopublished || 0,
            expired: data.expired || 0,
          };
        } else {
          // 没有 merchantId 时，返回数组，需要累加所有商家的数据
          const dataArray = res?.data || [];
          dataArray.forEach((item) => {
            statusCounts.pending += item.pend || 0;
            statusCounts.rejected += item.fail || 0;
            statusCounts.online += item.published || 0;
            statusCounts.offline += item.nopublished || 0;
            statusCounts.expired += item.expired || 0;
          });
        }
        
        this.statusCounts = statusCounts;
      });
    },
    // 获取优惠券列表
    tableList(curPage) {
      // 如果启用测试数据，直接使用测试数据
      if (this.useTestData) {
        this.search.page = curPage;
        this.loadTestCouponData();
        return;
      }
      
      // 根据筛选条件设置对应的参数
      const getFilterParams = () => {
        switch (this.search.status) {
          case "pending":
            return { auditStatus: 1 }; // 待审核
          case "rejected":
            return { auditStatus: 2 }; // 审核不通过
          case "online":
            return { auditStatus: 0, published: 1 }; // 审核通过且已发布
          case "offline":
            return { auditStatus: 0, published: 2 }; // 审核通过但未发布
          case "expired":
            return { status: 6 }; // 已过期
          default:
            return {}; // 全部
        }
      };
      //API调用
      const params = {
        ...this.search,
        page: curPage,
        ...getFilterParams(),
      };
      if (this.search.status !== "expired") {
        delete params.status; // 删除无用的status参数
      }
      // 如果merchantId为空字符串或undefined，则不传递该参数
      if (!params.merchantId || params.merchantId === "") {
        delete params.merchantId;
      }

      console.log("查询优惠券列表参数:", params);
      this.listLoading = true;
      this.$get(shopCouponList(), params).then((res) => {
        console.log("优惠券列表数据:", res);
        this.tableListData = res.data.rows || [];
        //翻页
        var pageObj = {
          curIndex: res.data.offset,
          rowsCount: res.data.total,
        };
        this.getPage(pageObj);
      }).catch((error) => {
        console.error("获取优惠券列表失败:", error);
        // 如果API失败，使用测试数据
        this.loadTestCouponData();
      }).finally(() => {
        this.listLoading = false;
      });
    },

    // 搜索
    searchList() {
      this.search.page = 1;
      this.tableList(1);
    },

    // 获取商家树数据
    getMerchantTree() {
      const params = {
        auditStatus: 0, // 只获取审核通过的商家
        limit: 1000, // 获取所有商家，不限制数量
        page: 1,
      };
      this.treeLoading = true;
      this.$get(shopMerchantList(), params)
        .then((res) => {
          console.log("商家列表数据:", res);
          const merchants = res.data?.rows || [];
          // 按分类组织成树形结构
          this.merchantTreeData = this.buildMerchantTree(merchants);
        })
        .catch((error) => {
          console.error("获取商家列表失败:", error);
        })
        .finally(() => {
          this.treeLoading = false;
        });
    },

    // 构建商家树形结构
    buildMerchantTree(merchants) {
      // 按分类分组
      const categoryMap = new Map();
      
      merchants.forEach((merchant) => {
        const categoryId = merchant.categoryId || "other";
        const categoryName = merchant.categoryName || "未分类";
        
        if (!categoryMap.has(categoryId)) {
          categoryMap.set(categoryId, {
            id: `category_${categoryId}`,
            name: categoryName,
            type: "category",
            children: [],
          });
        }
        
        // 添加商家节点
        categoryMap.get(categoryId).children.push({
          id: merchant.id,
          name: merchant.merchantName,
          type: "merchant",
          ...merchant,
        });
      });

      // 转换为数组
      const treeData = Array.from(categoryMap.values());
      
      // 如果没有分类，直接返回商家列表，并在顶层添加"全部商家"
      if (treeData.length === 0) {
        const merchantNodes = merchants.map((merchant) => ({
          id: merchant.id,
          name: merchant.merchantName,
          type: "merchant",
          ...merchant,
        }));
        
        return [
          {
            id: "all_merchants",
            name: "全部商家",
            type: "all",
            children: merchantNodes,
          },
        ];
      }

      // 在顶层添加"全部商家"节点
      return [
        {
          id: "all_merchants",
          name: "全部商家",
          type: "all",
          children: treeData,
        },
      ];
    },

    // 处理商家树节点点击
    handleTreeClick(data) {
      console.log("商家树节点点击:", data);
      
      // 处理"全部商家"节点 - merchantId 为空
      if (data.type === "all") {
        this.selectedMerchant = null;
        this.search.merchantId = "";
        this.search.page = 1;
        console.log("点击全部商家，merchantId 为空");
        this.tableList(1);
        this.getStatistics(); // 更新统计数据
      } else if (data.type === "merchant") {
        // 处理商家类型的节点 - merchantId 为对应商家的ID
        this.selectedMerchant = data;
        this.search.merchantId = data.id;
        this.search.page = 1;
        console.log("点击商家，merchantId:", data.id);
        this.tableList(1);
        this.getStatistics(); // 更新统计数据
      } else {
        // 如果点击的是分类节点，清空商家筛选 - merchantId 为空
        this.selectedMerchant = null;
        this.search.merchantId = "";
        this.search.page = 1;
        console.log("点击分类节点，merchantId 为空");
        this.tableList(1);
        this.getStatistics(); // 更新统计数据
      }
    },

    // 过滤商家树节点
    filterMerchantNode(value, data) {
      if (!value) return true;
      return data.name && data.name.indexOf(value) !== -1;
    },

    // 获取商家状态类型
    getMerchantStatusType(published) {
      switch (published) {
        case 1:
          return "success"; // 上架中
        case 2:
          return "info"; // 下架中
        default:
          return "info";
      }
    },

    // 获取商家状态文本
    getMerchantStatusText(published) {
      switch (published) {
        case 1:
          return "上架中";
        case 2:
          return "下架中";
        default:
          return "未知";
      }
    },

    // 重置表单
    resetForm() {
      this.couponForm = {
        id: null,
        couponName: "",
        couponType: "",
        couponContent: "",
        totalCount: 1,
        useTimeRange: "",
        shelfValidPeriod: [],
        useValidPeriod: [],
      };
      if (this.$refs.couponForm) {
        this.$refs.couponForm.resetFields();
      }
    },

    // 关闭对话框
    closeDialog() {
      this.showAddDialog = false;
      this.resetForm();
    },

    // 提交表单
    submitForm() {
      this.$refs.couponForm.validate((valid) => {
        if (valid) {
          const api = this.isEdit ? couponUpdate() : couponAdd();
          this.$post(api, this.couponForm).then((res) => {
            this.$message.success(this.isEdit ? "修改成功" : "添加成功");
            this.closeDialog();
            this.tableList(this.search.page);
          });
        }
      });
    },

    // 删除优惠券
    deleteCoupon(row) {
      this.$confirm("确定要删除该优惠券吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$delete(couponDelete(), { id: row.id }).then((res) => {
          this.$message.success("删除成功");
          this.tableList(this.search.page);
        });
      });
    },

    // 审核对话框（跳转到详情页面）
    auditDialog(row) {
      // 跳转到详情页面进行审核
      this.$router.push({
        name: "coupon-detail",
        params: { id: row.id, coupon: row },
        query: {
          couponName: row.couponName,
          merchantName: row.merchantName,
        },
      });
    },

    // 获取优惠券类型名称
    getCouponTypeName(type) {
      const typeMap = {
        1: "满减券",
        3: "折扣券",
        5: "抵扣券",
        4: "赠送券",
      };
      return typeMap[type] || "未知";
    },

    // 获取状态名称
    getStatusName(row) {
      // 根据优先级判断状态：已失效 > 审核不通过 > 待审核 > 下架中 > 上架中
      if (row.status === 2 || row.status === "2") {
        return "已失效";
      }
      if (row.auditStatus === 2 || row.auditStatus === "2") {
        return "审核不通过";
      }
      if (row.auditStatus === 1 || row.auditStatus === "1") {
        return "待审核";
      }
      if (row.published === 2 || row.published === "2") {
        return "下架中";
      }
      if (row.published === 1 || row.published === "1") {
        return "上架中";
      }
      return "未知";
    },

    // 获取状态类型
    getStatusType(row) {
      // 根据优先级判断状态类型：已失效 > 审核不通过 > 待审核 > 下架中 > 上架中
      if (row.status === 2 || row.status === "2") {
        return "info"; // 已失效
      }
      if (row.auditStatus === 2 || row.auditStatus === "2") {
        return "danger"; // 审核不通过
      }
      if (row.auditStatus === 1 || row.auditStatus === "1") {
        return "warning"; // 待审核
      }
      if (row.published === 2 || row.published === "2") {
        return "info"; // 下架中
      }
      if (row.published === 1 || row.published === "1") {
        return "success"; // 上架中
      }
      return "info"; // 默认
    },

    // 状态标签页切换
    handleStatusChange(tab) {
      console.log("切换到标签:", tab);
      this.search.status = tab.name === "all" ? "" : tab.name;
      this.search.page = 1;
      this.tableList(1);
    },

    // 查看详情
    viewDetail(row) {
      // 跳转到详情页面
      this.$router.push({
        name: "coupon-detail",
        params: { id: row.id, coupon: row },
        query: {
          couponName: row.couponName,
          merchantName: row.merchantName,
        },
      });
    },

    // 开始排序编辑
    startSortEdit(row) {
      console.log("开始编辑排序:", row);
      console.log("编辑前 editingSort:", row.editingSort);
      this.$set(row, 'editingSort', true);
      this.$set(row, 'tempSort', row.sort);
      console.log("编辑后 editingSort:", row.editingSort);
      console.log("tempSort:", row.tempSort);
    },

    // 确认排序编辑
    async confirmSortEdit(row) {
      try {
        if (row.tempSort === row.sort) {
          // 没有变化，直接取消编辑
          this.$set(row, 'editingSort', false);
          return;
        }

        const params = {
          id: row.id,
          sort: row.tempSort,
          published:1

        };
        
        // 调用实际的API接口
        const res = await this.$putRequest(`${shopCouponAudit()}/${row.id}`, params);
        if (res.status === 200) {
          this.$set(row, 'sort', row.tempSort);
          this.$set(row, 'editingSort', false);
          this.$message.success("排序更新成功");
          // 刷新列表
          this.tableList(this.curIndex || 1);
        } else {
          throw new Error(res.message || "排序更新失败");
        }
      } catch (error) {
        console.error("排序更新失败:", error);
        // 恢复原值
        this.$set(row, 'tempSort', row.sort);
        this.$set(row, 'editingSort', false);
      }
    },

    // 取消排序编辑
    cancelSortEdit(row) {
      this.$set(row, 'tempSort', row.sort);
      this.$set(row, 'editingSort', false);
    },

    // 打开抽奖规则设置弹窗
    openLotteryRuleDialog(row) {
      this.currentCouponId = row.id;
      this.currentCouponName = row.name || "";
      this.lotteryRuleTitle = this.currentCouponName
        ? `抽奖规则 - ${this.currentCouponName}`
        : "抽奖规则";
      
      // 先重置表单为默认值
      this.lotteryRuleForm = {
        unawarePayWeight: 0,
        scanPayWeight: 0,
        miniProgramPayWeight: 0,
        dailyMaxIssue: 0,
        repeatObtainInterval: 0,
        defaultConsolationPrize: false,
      };
      this.hasLotteryConfig = false; // 重置标志位
      this.lotteryConfigId = null; // 重置配置ID
      
      this.showLotteryRuleDrawer = true;
      
      // 调用GET接口获取抽奖规则配置
      this.$get(couponLotteryConfigSelect(), { couponId: row.id })
        .then((res) => {
          if (res.status === 200 && res.data) {
            const data = res.data;
            // 判断是否有返回数据（可以根据id或其他字段判断）
            if (data.id || data.couponId) {
              this.hasLotteryConfig = true; // 存在配置数据
              this.lotteryConfigId = data.id || null; // 保存配置的ID
              // 回显数据
              this.lotteryRuleForm = {
                unawarePayWeight: data.unawarePayWeight || 0,
                scanPayWeight: data.scanPayWeight || 0,
                miniProgramPayWeight: data.miniProgramPayWeight || 0,
                dailyMaxIssue: data.dailyMaxIssue || 0,
                repeatObtainInterval: data.repeatObtainInterval ? Math.floor(data.repeatObtainInterval / 86400) : 0, // 秒转天
                defaultConsolationPrize: data.defaultConsolationPrize === true || data.defaultConsolationPrize === 1 || data.defaultConsolationPrize === "1",
                id: data.id || null, // 可能需要保存ID用于后续更新操作
              };
            } else {
              this.hasLotteryConfig = false; // 不存在配置数据
              this.lotteryConfigId = null; // 重置ID
            }
          } else {
            this.hasLotteryConfig = false; // 没有返回数据
          }
        })
        .catch((error) => {
          console.error("获取抽奖规则配置失败:", error);
          this.hasLotteryConfig = false; // 获取失败，视为不存在
          // 如果获取失败，使用默认值，不显示错误提示
        });
    },

    // 关闭抽奖规则设置弹窗
    closeLotteryRuleDrawer() {
      this.showLotteryRuleDrawer = false;
      this.currentCouponId = null;
      this.hasLotteryConfig = false; // 重置标志位
      this.lotteryConfigId = null; // 重置配置ID
      // 重置表单
      this.$nextTick(() => {
        if (this.$refs.lotteryRuleForm) {
          this.$refs.lotteryRuleForm.resetFields();
        }
      });
    },

    // 提交抽奖规则设置
    submitLotteryRule() {
      this.$refs.lotteryRuleForm.validate((valid) => {
        if (valid) {
          const params = {
            couponId: this.currentCouponId,
            unawarePayWeight: this.lotteryRuleForm.unawarePayWeight,
            scanPayWeight: this.lotteryRuleForm.scanPayWeight,
            miniProgramPayWeight: this.lotteryRuleForm.miniProgramPayWeight,
            dailyMaxIssue: this.lotteryRuleForm.dailyMaxIssue,
            repeatObtainInterval: this.lotteryRuleForm.repeatObtainInterval * 86400, // 天转秒
            defaultConsolationPrize: this.lotteryRuleForm.defaultConsolationPrize ? 1 : 0, // true转为1，false转为0
            id: this.lotteryRuleForm.id||null,
          };

          // 根据是否存在配置数据决定使用PUT还是POST
          let apiCall;
          if (this.hasLotteryConfig && this.lotteryConfigId) {
            // 存在配置，使用PUT请求更新：/api/onsite/couponLotteryConfig/{id}
            apiCall = this.$putRequest(`${couponLotteryConfig()}/${this.lotteryConfigId}`, params);
          } else {
            // 不存在配置，使用POST请求创建：/api/onsite/couponLotteryConfig
            apiCall = this.$postRequest(couponLotteryConfig(), params);
          }

          apiCall
            .then((res) => {
              if (res.status === 200) {
                this.$message.success("抽奖规则设置成功");
                this.hasLotteryConfig = true; // 设置成功后，标记为已存在
                this.closeLotteryRuleDrawer();
                // 刷新列表
                this.tableList(this.curIndex || 1);
              } else {
                this.$message.error(res.message || "设置失败");
              }
            })
            .catch((error) => {
              console.error("设置抽奖规则失败:", error);
            });
        } else {
          return false;
        }
      });
    },

    // 获取所有测试数据
    getAllTestData() {
      return [
        {
          id: 1,
          merchantId: 1,
          merchantName: "星巴克咖啡",
          name: "新用户满减券",
          discountType: 1,
          totalNum: 1000,
          issueNum: 856,
          usedNum: 234,
          issueBeginTime: "2024-01-01",
          issueEndTime: "2024-12-31",
          termBeginTime: "2024-01-01",
          termEndTime: "2024-12-31",
          durationStart: "09:00",
          durationEnd: "22:00",
          status: 1,
          auditStatus: 0, // 已审核通过
          published: 1, // 上架中
          sort: 1,
          editingSort: false,
          crtTime: "2024-01-15 10:30:00",
          updTime: "2024-01-20 14:20:00"
        },
        {
          id: 2,
          merchantId: 2,
          merchantName: "海底捞火锅",
          name: "周末折扣券",
          discountType: 3,
          totalNum: 500,
          issueNum: 234,
          usedNum: 123,
          issueBeginTime: "2024-01-01",
          issueEndTime: "2024-12-31",
          termBeginTime: "2024-01-01",
          termEndTime: "2024-12-31",
          durationStart: "11:00",
          durationEnd: "23:00",
          status: 1,
          auditStatus: 1, // 待审核
          sort: 2,
          editingSort: false,
          crtTime: "2024-01-20 14:20:00",
          updTime: "2024-01-22 09:15:00"
        },
        {
          id: 3,
          merchantId: 3,
          merchantName: "优衣库",
          name: "代金券",
          discountType: 5,
          totalNum: 200,
          issueNum: 89,
          usedNum: 45,
          issueBeginTime: "2024-01-01",
          issueEndTime: "2024-12-31",
          termBeginTime: "2024-01-01",
          termEndTime: "2024-12-31",
          durationStart: "10:00",
          durationEnd: "22:00",
          status: 2,
          auditStatus: 2, // 审核不通过
          sort: 3,
          editingSort: false,
          crtTime: "2024-02-01 09:15:00",
          updTime: "2024-02-05 16:45:00"
        },
        {
          id: 4,
          merchantId: 4,
          merchantName: "万达影城",
          name: "电影票优惠券",
          discountType: 1,
          totalNum: 300,
          issueNum: 156,
          usedNum: 78,
          issueBeginTime: "2024-01-01",
          issueEndTime: "2024-12-31",
          termBeginTime: "2024-01-01",
          termEndTime: "2024-12-31",
          durationStart: "09:00",
          durationEnd: "24:00",
          status: 1,
          auditStatus: 0, // 已审核通过
          published: 2, // 下架中
          sort: 4,
          editingSort: false,
          crtTime: "2024-02-10 16:45:00",
          updTime: "2024-02-15 11:30:00"
        },
        {
          id: 5,
          merchantId: 5,
          merchantName: "肯德基",
          name: "早餐优惠券",
          discountType: 4,
          totalNum: 800,
          issueNum: 567,
          usedNum: 234,
          issueBeginTime: "2024-01-01",
          issueEndTime: "2024-12-31",
          termBeginTime: "2024-01-01",
          termEndTime: "2024-12-31",
          durationStart: "06:00",
          durationEnd: "10:00",
          status: 2,
          auditStatus: 0, // 已审核通过
          published: 1, // 上架中
          sort: 5,
          editingSort: false,
          crtTime: "2024-02-15 11:30:00",
          updTime: "2024-02-20 09:00:00"
        },
        {
          id: 6,
          merchantId: 6,
          merchantName: "麦当劳",
          name: "午餐满减券",
          discountType: 1,
          totalNum: 600,
          issueNum: 445,
          usedNum: 189,
          issueBeginTime: "2024-01-01",
          issueEndTime: "2024-12-31",
          termBeginTime: "2024-01-01",
          termEndTime: "2024-12-31",
          durationStart: "11:00",
          durationEnd: "14:00",
          status: 1,
          auditStatus: 1, // 待审核
          sort: 6,
          editingSort: false,
          crtTime: "2024-02-20 09:00:00",
          updTime: "2024-02-22 15:30:00"
        },
        {
          id: 7,
          merchantId: 7,
          merchantName: "必胜客",
          name: "披萨折扣券",
          discountType: 3,
          totalNum: 400,
          issueNum: 278,
          usedNum: 156,
          issueBeginTime: "2024-01-01",
          issueEndTime: "2024-12-31",
          termBeginTime: "2024-01-01",
          termEndTime: "2024-12-31",
          durationStart: "17:00",
          durationEnd: "22:00",
          status: 1,
          auditStatus: 2, // 审核不通过
          sort: 7,
          editingSort: false,
          crtTime: "2024-02-22 15:30:00",
          updTime: "2024-02-25 10:20:00"
        },
        {
          id: 8,
          merchantId: 8,
          merchantName: "永辉超市",
          name: "购物抵扣券",
          discountType: 5,
          totalNum: 1200,
          issueNum: 890,
          usedNum: 456,
          issueBeginTime: "2024-01-01",
          issueEndTime: "2024-12-31",
          termBeginTime: "2024-01-01",
          termEndTime: "2024-12-31",
          durationStart: "08:00",
          durationEnd: "22:00",
          status: 1,
          auditStatus: 0, // 已审核通过
          published: 1, // 上架中
          sort: 8,
          editingSort: false,
          crtTime: "2024-02-25 10:20:00",
          updTime: "2024-02-28 14:10:00"
        },
        {
          id: 9,
          merchantId: 9,
          merchantName: "家乐福",
          name: "生鲜赠送券",
          discountType: 4,
          totalNum: 700,
          issueNum: 523,
          usedNum: 267,
          issueBeginTime: "2024-01-01",
          issueEndTime: "2024-12-31",
          termBeginTime: "2024-01-01",
          termEndTime: "2024-12-31",
          durationStart: "09:00",
          durationEnd: "21:00",
          status: 1,
          auditStatus: 0, // 已审核通过
          published: 2, // 下架中
          sort: 9,
          editingSort: false,
          crtTime: "2024-02-28 14:10:00",
          updTime: "2024-03-01 11:00:00"
        },
        {
          id: 10,
          merchantId: 10,
          merchantName: "7-ELEVEN",
          name: "夜宵优惠券",
          discountType: 1,
          totalNum: 350,
          issueNum: 234,
          usedNum: 98,
          issueBeginTime: "2024-01-01",
          issueEndTime: "2024-12-31",
          termBeginTime: "2024-01-01",
          termEndTime: "2024-12-31",
          durationStart: "22:00",
          durationEnd: "06:00",
          status: 2,
          auditStatus: 0, // 已审核通过
          published: 1, // 上架中
          sort: 10,
          editingSort: false,
          crtTime: "2024-03-01 11:00:00",
          updTime: "2024-03-05 16:30:00"
        }
      ];
    },

    // 加载测试优惠券数据（支持筛选和分页）
    loadTestCouponData() {
      let allData = this.getAllTestData();
      
      // 根据筛选条件过滤数据
      let filteredData = this.filterTestData(allData);
      
      // 分页处理
      const page = this.search.page || 1;
      const limit = this.search.limit || 10;
      const start = (page - 1) * limit;
      const end = start + limit;
      const paginatedData = filteredData.slice(start, end);
      
      this.tableListData = paginatedData;
      this.total = filteredData.length;
      
      // 设置分页信息
      var pageObj = {
        curIndex: page,
        rowsCount: filteredData.length,
      };
      this.getPage(pageObj);
    },

    // 过滤测试数据
    filterTestData(data) {
      let filtered = [...data];
      
      // 按优惠券名称筛选
      if (this.search.couponName) {
        filtered = filtered.filter(item => 
          item.name && item.name.includes(this.search.couponName)
        );
      }
      
      // 按优惠券类型筛选
      if (this.search.discountType) {
        filtered = filtered.filter(item => 
          item.discountType == this.search.discountType
        );
      }
      
      // 按商家ID筛选
      if (this.search.merchantId && this.search.merchantId !== "") {
        filtered = filtered.filter(item => 
          item.merchantId == this.search.merchantId
        );
      }
      
      // 按状态筛选
      if (this.search.status) {
        switch (this.search.status) {
          case "pending":
            filtered = filtered.filter(item => item.auditStatus === 1);
            break;
          case "rejected":
            filtered = filtered.filter(item => item.auditStatus === 2);
            break;
          case "online":
            filtered = filtered.filter(item => item.auditStatus === 0 && item.published === 1);
            break;
          case "offline":
            filtered = filtered.filter(item => item.auditStatus === 0 && item.published === 2);
            break;
          case "expired":
            filtered = filtered.filter(item => item.status === 2);
            break;
        }
      }
      
      return filtered;
    },
  },
};
</script>

<style scoped>
.el-tag {
  margin: 0;
}

/* 状态标签页样式 */
.status-tabs {
  margin-bottom: 20px;
  background: #fff;
  padding: 0 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.status-tabs .el-tabs__header {
  margin: 0;
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav-wrap::after {
  display: none !important;
  content: none !important;
}

.status-tabs .el-tabs__nav-wrap {
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav-wrap::before {
  display: none !important;
  content: none !important;
}

.status-tabs .el-tabs__active-bar {
  display: none;
}

.status-tabs .el-tabs__item {
  border-bottom: none !important;
}

.status-tabs .el-tabs__content {
  border: none !important;
}

.status-tabs .el-tabs__header::after {
  display: none !important;
  content: none !important;
}

.status-tabs .el-tabs__header::before {
  display: none !important;
  content: none !important;
}

/* 强制移除所有可能的边框 */
.status-tabs .el-tabs {
  border: none !important;
}

.status-tabs .el-tabs__header {
  border: none !important;
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav {
  border: none !important;
}

.status-tabs .el-tabs__nav-wrap {
  border: none !important;
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav-scroll {
  border: none !important;
}

/* 移除所有伪元素的边框 */
.status-tabs *::before,
.status-tabs *::after {
  border: none !important;
  border-bottom: none !important;
}

/* 使用深度选择器强制覆盖 */
.status-tabs >>> .el-tabs__header {
  border-bottom: none !important;
}

.status-tabs >>> .el-tabs__nav-wrap::after {
  display: none !important;
}

.status-tabs >>> .el-tabs__nav-wrap {
  border-bottom: none !important;
}

/* 如果还是不行，尝试更具体的选择器 */
.status-tabs .el-tabs__header .el-tabs__nav-wrap::after {
  display: none !important;
  content: none !important;
  border: none !important;
}

.status-badge {
  margin-left: 8px;
}
.coupon-list .list-right {
  height: calc(100vh - 400px) !important;
}

/* 左右布局样式 */
.coupon-list {
  display: flex;
  height: calc(100vh - 100px);
}

.coupon-list .left {
  float: left;
  width: 300px;
  min-width: 300px;
  border-right: 10px solid #eff2f7;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.coupon-list .right {
  flex: 1;
  float: right;
  width: calc(100% - 310px);
  height: 100%;
  padding-left: 10px;
  overflow-y: auto;
  box-sizing: border-box;
}

/* 排序编辑样式 */
.sort-edit-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sort-display {
  display: flex;
  align-items: center;
  gap: 5px;
}

.sort-edit-icon {
  cursor: pointer;
  color: #409eff;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.sort-edit-icon:hover {
  opacity: 1;
}

.sort-edit-input {
  display: flex;
  align-items: center;
  gap: 5px;
}

.sort-confirm-icon {
  cursor: pointer;
  color: #67c23a;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.sort-confirm-icon:hover {
  opacity: 1;
}

.sort-cancel-icon {
  cursor: pointer;
  color: #f56c6c;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.sort-cancel-icon:hover {
  opacity: 1;
}

/* 左右布局样式 */
.coupon-list {
  display: flex;
  height: calc(100vh - 100px);
}

.coupon-list .left {
  width: 220px;
  min-width: 220px;
  border-right: 10px solid #eff2f7;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.coupon-list .right {
  flex: 1;
  width: calc(100% - 230px);
  height: 100%;
  padding-left: 10px;
  overflow-y: auto;
  box-sizing: border-box;
}

/* 商家树样式 */
.merchant-tree {
  height: 100%;
  padding: 8px 5px 0 5px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.merchant-tree .search {
  margin-bottom: 8px;
  border-radius: 4px;
}

.merchant-tree .search .el-input__inner {
  font-size: 12px;
  padding: 5px 10px;
  height: 28px;
  line-height: 28px;
}

.merchant-tree .el-tree {
  flex: 1;
  overflow: auto;
  color: #5c5c5c;
  font-size: 12px;
}

.merchant-tree .el-tree-node__label {
  font-size: 12px;
}

.merchant-tree-node {
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 12px;
}

.merchant-name-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  padding-right: 50px;
  box-sizing: border-box;
}

.merchant-name {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  font-size: 12px;
  cursor: default;
}

.merchant-status-badge {
  position: absolute;
  /* top: -8px;
  right: 0; */
  z-index: 10;
}

.merchant-status-badge .el-tag {
  transform: scale(0.75);
  font-size: 10px;
  line-height: 1.2;
  padding: 1px 4px;
  white-space: nowrap;
  margin: 0;
}

.el-tree-node__content {
  position: relative;
}

/* 抽奖规则弹窗样式优化 */
.el-drawer__body {
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.lottery-rule-form {
  flex: 1;
  overflow-y: auto;
}

.lottery-rule-form .el-form-item {
  margin-bottom: 22px;
}

.lottery-rule-form .el-form-item__label {
  font-weight: 500;
  color: #303133;
}

/* 支付方式权重区域样式 */
.payment-weight-container {
  width: 100%;
}

.payment-weight-item {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}

.payment-weight-item:last-of-type {
  margin-bottom: 0;
}

.payment-weight-label {
  display: inline-block;
  width: 90px;
  color: #606266;
  font-size: 14px;
  margin-right: 10px;
}

.payment-weight-tip {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
  display: flex;
  align-items: flex-start;
  line-height: 1.5;
}
</style>
